<template>
  <div :class="navClass">
    <ul class="nav-box">
      <li
        v-for="(depth1, idx) in menu as Array<RouteRecordRaw>"
        :key="idx"
        @mouseover="hoveredIdx = idx"
        @mouseleave="hoveredIdx = null"
        class="gnb"
      >
        <router-link :to="depth1?.redirect as RouteLocationRaw">
          {{ depth1?.meta?.breadcrumbName }}
        </router-link>
        <ul v-if="hoveredIdx === idx" class="lnb">
          <li v-for="(child, cIdx) in depth1.children" :key="cIdx">
            <router-link :to="{ name: child?.name }">
              {{ child?.meta?.breadcrumbName }}
            </router-link>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
<script setup lang="ts">
import routes from '@infra/router/routes.ts';
import { RouteLocationRaw, RouteRecordRaw } from 'vue-router';
import { computed, ref } from 'vue';
import { useCommonStore, useUserStore } from '@stores';
import router from '@infra/router';
import { ROUTE_NAME } from '@constants';

const userStore = useUserStore();
const commonStore = useCommonStore();
const isAdmin = computed(() => userStore.grant === 'WEB_ADMIN');
const isMain = computed(() => {
  return router.currentRoute.value.name === ROUTE_NAME.Main;
});
const navClass = computed(() => {
  if (isMain.value) {
    return 'nav-wrap-isMain';
  } else {
    return 'nav-wrap';
  }
});
const menu = computed(() =>
  routes
    .map((route) => {
      if (route.children) {
        const filteredChildren = route.children.filter((child) => {
          if (child?.meta?.isAdmin) {
            return isAdmin.value;
          }
          //비밀번호변경 메뉴는 로그인 상태에서만 노출
          if (child.name === ROUTE_NAME.NewPasswordAccount) {
            return commonStore.isSignIn;
          }
          return child.meta?.breadcrumb;
        });
        if (filteredChildren.length > 0) {
          return {
            ...route,
            children: filteredChildren,
          };
        }
      }

      return null;
    })
    .filter((route) => route !== null)
);
const hoveredIdx = ref<number | null>(null);
</script>

<style scoped lang="scss">
//Main
.nav-wrap-isMain .nav-box {
  width: 810px;
  height: 88px;
  margin: auto;
  display: flex;
  align-items: center;
}

.nav-wrap-isMain .nav-box .gnb {
  width: calc(100% / 7);
  //  padding: 30px 0;
  font-weight: 500;
  font-size: 18px;
  color: #fff;
  text-align: center;
  cursor: pointer;
}

.nav-wrap-isMain .nav-box .gnb a {
  display: block;
  padding: 30px 0;
}

.nav-wrap-isMain .nav-box .gnb:hover {
  color: #fff;
  font-weight: bold;
}

.nav-wrap-isMain .nav-box .gnb .lnb {
  position: absolute;
  top: 88px;
  height: 68px;
  left: 0;
  width: 100%;
  display: flex;
  background-color: var(--color-main);
  color: #fff;
  justify-content: center;
  align-items: center;
  gap: 0 64px;
  cursor: default;
}

.nav-wrap-isMain .nav-box .gnb .lnb li {
  position: relative;
  font-size: 17px;
  font-weight: 400;
  color: #eee;
}

.nav-wrap-isMain .nav-box .gnb .lnb li:hover {
  font-weight: bold;
  color: #fff;
}

.nav-wrap-isMain .nav-box .gnb .lnb li::after {
  content: '';
  width: 1px;
  height: 12px;
  background-color: #ccc;
  position: absolute;
  top: 50%;
  right: -34px;
  transform: translateY(-50%);
}

.nav-wrap-isMain .nav-box .gnb .lnb li:last-child::after {
  display: none;
}

.nav-wrap-isMain.main .nav-box .gnb {
  color: #fff;
}

//메인헤더+hover
.header-isMain:hover .nav-wrap-isMain .nav-box .gnb {
  color: #222;
}
.header-isMain:hover .nav-wrap-isMain .nav-box .gnb:hover {
  color: var(--color-main);
}

//The others
.nav-wrap .nav-box {
  width: 810px;
  height: 88px;
  margin: auto;
  display: flex;
  align-items: center;
}

.nav-wrap .nav-box .gnb {
  width: calc(100% / 7);
  //  padding: 30px 0;
  font-weight: 500;
  font-size: 18px;
  color: #222;
  text-align: center;
  cursor: pointer;
}

.nav-wrap .nav-box .gnb a {
  display: block;
  padding: 30px 0;
}

.nav-wrap .nav-box .gnb:hover {
  color: var(--color-main);
  font-weight: bold;
}

.nav-wrap .nav-box .gnb .lnb {
  position: absolute;
  top: 88px;
  height: 68px;
  left: 0;
  width: 100%;
  display: flex;
  background-color: var(--color-main);
  color: #fff;
  justify-content: center;
  align-items: center;
  gap: 0 64px;
  cursor: default;
}

.nav-wrap .nav-box .gnb .lnb li {
  position: relative;
  font-size: 17px;
  font-weight: 400;
  color: #eee;
}

.nav-wrap .nav-box .gnb .lnb li:hover {
  font-weight: bold;
  color: #fff;
}

.nav-wrap .nav-box .gnb .lnb li::after {
  content: '';
  width: 1px;
  height: 12px;
  background-color: #ccc;
  position: absolute;
  top: 50%;
  right: -34px;
  transform: translateY(-50%);
}

.nav-wrap .nav-box .gnb .lnb li:last-child::after {
  display: none;
}
</style>
